import axios from "axios";
import debounce from "lodash.debounce";

const state = {
  agendaToken: "",
  selectToken: ""
};

const mutations = {
  setAgendaToken: (state, agendaToken) => {
    state.agendaToken = agendaToken;
  },
  setSelectToken: (state, selectToken) => {
    state.selectToken = selectToken;
  }
};

const actions = {
  exchangeAgendaToken: debounce(async ({ commit }, { url, ticket }) => {
    try {
      const { data } = await axios.get(`${url}?ticket=${ticket}&direct=true`);
      commit("setAgendaToken", data.token);
    } catch (error) {
      throw error;
    }
  }, 500),
  exchangeSelectToken: debounce(async ({ commit }, { url, ticket }) => {
    try {
      const { data } = await axios.get(`${url}?ticket=${ticket}&direct=true`);
      commit("setSelectToken", data.token);
    } catch (error) {
      throw error;
    }
  }, 500)
};

export default {
  state,
  mutations,
  actions,
  namespaced: true
};
